import { render, staticRenderFns } from "./MenuContent.vue?vue&type=template&id=846f2d88&"
import script from "./MenuContent.vue?vue&type=script&lang=js&"
export * from "./MenuContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports